export default __webpack_public_path__ + "static/media/work3.e0f7262b.jpg";